import React, { useState, useEffect } from 'react';

interface TimeIndicatorProps {
  view: 'week' | 'day';
}

export default function TimeIndicator({ view }: TimeIndicatorProps) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    // Update immediately
    setNow(new Date());
    
    // Update every minute
    const timer = setInterval(() => {
      setNow(new Date());
    }, 60000);
    
    return () => clearInterval(timer);
  }, []);

  const hours = now.getHours();
  const minutes = now.getMinutes();
  // Calculate position based on 48px per hour (each hour slot is 48px tall)
  const top = (hours * 48) + (minutes / 60) * 48;

  return (
    <div 
      className="absolute left-0 right-0 pointer-events-none z-50 transition-transform duration-300"
      style={{ top: `${top}px` }}
    >
      {/* Dot indicator */}
      <div 
        className="absolute left-20 w-3 h-3 rounded-full bg-red-500 transform -translate-x-1/2 -translate-y-1/2"
        style={{ marginLeft: view === 'week' ? '0' : '-10px' }}
      />
      
      {/* Line */}
      <div className="absolute left-20 right-0 h-[2px] bg-red-500" />
    </div>
  );
}